// extracted by mini-css-extract-plugin
export default {"statistics_block":"ShortStatistics_statistics_block__-seZ1","statistics_text":"ShortStatistics_statistics_text__dLpVI"};